const stripHTML = (input: string): string => {
  return input.replace(/(<([^>]+)>)/gi, '').replace('&nbsp;', ' ').replace('&reg;', '®').replace('&tm;', '™');
}

export default stripHTML;


// WEBPACK FOOTER //
// ./src/utils/stripHTML.ts